function EventDetails() {
  return <h1>Event Details Page</h1>;
}

export default EventDetails;